module.exports = __webpack_public_path__ + "static/media/tetero-button-hover.ed05ddcd.png";